import { render, staticRenderFns } from "./overviewGreen.vue?vue&type=template&id=936d3c66&scoped=true&"
import script from "./overviewGreen.vue?vue&type=script&lang=js&"
export * from "./overviewGreen.vue?vue&type=script&lang=js&"
import style0 from "./overviewGreen.vue?vue&type=style&index=0&id=936d3c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d3c66",
  null
  
)

export default component.exports